module.exports = __webpack_public_path__ + "media/src/images/abouts/items/delivery/kose_1100-374eea8388cc928d9093b2f688327046.jpg";